import { ClientRender } from '@/components/shared/client-render'
import { GptLeader } from '@/components-page/vip/advertisement/GptLeader'
import { GptR2S } from '@/components-page/vip/advertisement/GptR2S'
import { GptLeaderWrapper } from '@/components-page/vip/advertisement/styled'

type GptLeaderProps = {
  isFormSubmitSuccess: boolean
}

/**
 * Displays either the GptLeader or GptR2S ad slot,
 * based on whether the R2S form is has been submitted successfully
 */
export const TopBannerSlots = ({ isFormSubmitSuccess }: GptLeaderProps) => {
  return (
    <GptLeaderWrapper>
      {/* must apply min-height outside of ClientRender to prevent layout shift */}
      <ClientRender>{isFormSubmitSuccess ? <GptR2S /> : <GptLeader />}</ClientRender>
    </GptLeaderWrapper>
  )
}
